var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c(
            "div",
            { staticClass: "page-name", attrs: { id: "benefitHeader" } },
            [_vm._v(_vm._s(_vm.pageTitle))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "back_button btn btn-primary pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack.apply(null, arguments)
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("form", { attrs: { id: "changeProfile" } }, [
            _c("div", { staticClass: "forms-container" }, [
              _c(
                "div",
                { staticClass: "row no-margin" },
                [
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.socialMedia,
                              expression: "socialMedia"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "socialMedia",
                            placeholder: "Social Media"
                          },
                          domProps: { value: _vm.socialMedia },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.socialMedia = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.socialMediaError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.email != null,
                          expression: "email != null"
                        }
                      ],
                      staticClass: "col-6 forms-block"
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-9 paddingleft0" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.email,
                                expression: "email"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "email",
                              placeholder: "Email"
                            },
                            domProps: { value: _vm.email },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.email = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "requiredstar" }, [
                            _vm._v("*")
                          ]),
                          _vm._v(" "),
                          _c("font", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.emailError))
                          ])
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.profileUser,
                              expression: "profileUser"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "profileUser",
                            placeholder: "Profile User"
                          },
                          domProps: { value: _vm.profileUser },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.profileUser = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.profileUserError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c(
                          "v-select",
                          {
                            attrs: {
                              name: "companyId",
                              id: "companyId",
                              label: "text",
                              filterable: false,
                              options: _vm.companyArr,
                              placeholder: "Select Company"
                            },
                            on: {
                              change: _vm.changedValue,
                              input: function($event) {
                                return _vm.changedValueUser()
                              },
                              search: _vm.onSearchCompany
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "option",
                                fn: function(option) {
                                  return [
                                    _c("div", { staticClass: "d-center" }, [
                                      _vm._v(
                                        "\n                                              " +
                                          _vm._s(option.text) +
                                          "\n                                          "
                                      )
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "selected-option",
                                fn: function(option) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "selected d-center" },
                                      [
                                        _vm._v(
                                          "\n                                              " +
                                            _vm._s(option.text) +
                                            "\n                                          "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.company,
                              callback: function($$v) {
                                _vm.company = $$v
                              },
                              expression: "company"
                            }
                          },
                          [
                            _c("template", { slot: "no-options" }, [
                              _vm._v(
                                "\n                                          Search Company...\n                                      "
                              )
                            ])
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.companyError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.pages, function(page) {
                    return [
                      page != ""
                        ? _c("div", { staticClass: "col-6 forms-block" }, [
                            _c("div", { staticClass: "col-3 paddingleft0" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form-label",
                                  attrs: { for: "description" }
                                },
                                [_vm._v(_vm._s(_vm.pageNameTitle) + " :")]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-9 paddingleft0" },
                              [
                                _c("input", {
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    id: "pageName",
                                    placeholder: "Page Name",
                                    disabled: ""
                                  },
                                  domProps: { value: page }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "requiredstar" }, [
                                  _vm._v("*")
                                ]),
                                _vm._v(" "),
                                _c("font", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.pageNameError))
                                ])
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ]
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.createdBy,
                              expression: "createdBy"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "createdBy",
                            placeholder: "Created By"
                          },
                          domProps: { value: _vm.createdBy },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.createdBy = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.createdByError))
                        ])
                      ],
                      1
                    )
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _vm._m(5),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "row clearfix" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12" },
                [
                  _c("div", { staticClass: "button-demo" }, [
                    _c("input", {
                      staticClass: "btn btn-primary",
                      attrs: {
                        id: "addBenifitBtn",
                        type: "submit",
                        value: "Update"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.UpdateAccount()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "back_button btn btn-primary",
                      attrs: {
                        id: "CancelBenifit",
                        type: "submit",
                        value: "Cancel"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.buttonBack.apply(null, arguments)
                        }
                      }
                    })
                  ])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "description" } }, [
        _vm._v("Social Media :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "description" } }, [
        _vm._v("Email :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "description" } }, [
        _vm._v("Profile User :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "description" } }, [
        _vm._v("Company :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "description" } }, [
        _vm._v("Created By :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b8b45a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b8b45a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/socialmedia/ViewSocialAccount.vue
// module id = null
// module chunks = 